import Vue from 'vue';
import Vuex from 'vuex';
import application from './modules/application';
import newApplication from './modules/newApplication';
import user from './modules/user';
import context from './modules/context';
import getters from './getters';

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    newApplication,
    application,
    user,
    context,
  },
  getters,
});

export default store;
